import {Typography} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid';
import {t} from 'i18next';

export const annotationColumns: GridColDef[] = [
  {
    field: 'layerName',
    headerName: t('annotationLayer.layerName'),
    flex: 1,
    renderHeader: () => (
      <Typography
        data-testid="annotation-layerName-header"
        tabIndex={0}
        className="typo-text label2_size"
      >
        {t('annotationLayer.layerName')}
      </Typography>
    ),
    renderCell: (params) => (
      <span
        tabIndex={0}
        className="cell-label"
        data-testid={`cell-layerName-${params.id}`}
      >
        {params.value}
      </span>
    ),
  },
  {
    field: 'description',
    headerName: t('annotationLayer.description'),
    flex: 1,
    renderHeader: () => (
      <Typography
        data-testid="annotation-description-header"
        tabIndex={0}
        className="typo-text label2_size"
      >
        {t('annotationLayer.description')}
      </Typography>
    ),
    renderCell: (params) => (
      <span
        tabIndex={0}
        className="cell-label"
        data-testid={`cell-description-${params.id}`}
      >
        {params.value}
      </span>
    ),
  },
];
